import { useCallback, useContext } from 'react';
import { GraphActionType, GraphContext } from '@core/context/GraphContext';
import {
  AcknowledgeFilterType,
  AlarmFromDatesType,
  GraphIntervalType,
  GraphPage,
  LogsShowFilterType,
  RangeType,
  RefreshButtonModel,
  FlowUnitsAPIType,
  PressureUnitsAPIType,
} from '@shared/models';
import {
  LogsActionType,
  LogsContext,
  SharedActionType,
  SharedContext,
  AlarmsContext,
  AlarmsActionType,
} from '@core/context';

export const useFiltersContext = () => {
  // shared context
  const { state: sharedState, dispatch: sharedDispatch } = useContext(SharedContext);

  const setRangeFilter = useCallback(
    (payload: [Date, Date]) => {
      sharedDispatch({ type: SharedActionType.SetRange, payload });
    },
    [sharedDispatch]
  );
  const setPageContext = useCallback(
    (payload: string) => {
      sharedDispatch({ type: SharedActionType.SetPageContext, payload });
    },
    [sharedDispatch]
  );
  const setRefreshButton = useCallback(
    (payload: RefreshButtonModel) => {
      sharedDispatch({ type: SharedActionType.SetRefreshButton, payload });
    },
    [sharedDispatch]
  );
  const setShowAllocatedSites = useCallback(
    (payload: boolean) => {
      sharedDispatch({ type: SharedActionType.SetShowAllocatedSites, payload });
    },
    [sharedDispatch]
  );

  // graph context
  const { state: graphState, dispatch: graphDispatch } = useContext(GraphContext);

  const setIntervalFilter = useCallback(
    (payload: GraphIntervalType) => {
      graphDispatch({ type: GraphActionType.SetInterval, payload });
    },
    [graphDispatch]
  );
  const setFlowUnitFilter = useCallback(
    (payload: FlowUnitsAPIType) => {
      graphDispatch({ type: GraphActionType.SetFlowUnit, payload });
    },
    [graphDispatch]
  );
  const setPressureUnitFilter = useCallback(
    (payload: PressureUnitsAPIType) => {
      graphDispatch({ type: GraphActionType.SetPressureUnit, payload });
    },
    [graphDispatch]
  );
  const setMaintenanceSiteIdsFilter = useCallback(
    (payload: number[]) => {
      graphDispatch({ type: GraphActionType.SetMaintenanceSiteIds, payload });
    },
    [graphDispatch]
  );
  const setMaintenanceRangeTypeFilter = useCallback(
    (payload: RangeType) => {
      graphDispatch({ type: GraphActionType.SetMaintenanceRangeType, payload });
    },
    [graphDispatch]
  );
  const setGraphPage = useCallback(
    (payload: GraphPage) => {
      graphDispatch({ type: GraphActionType.SetGraphPage, payload });
    },
    [graphDispatch]
  );

  // logs context
  const { state: logsState, dispatch: logsDispatch } = useContext(LogsContext);

  const setIncludeDeviceCommands = useCallback(
    (payload: boolean) => {
      logsDispatch({ type: LogsActionType.SetIncludeDeviceCommands, payload });
    },
    [logsDispatch]
  );
  const setActiveCommands = useCallback(
    (payload: boolean) => {
      logsDispatch({ type: LogsActionType.SetActiveCommands, payload });
    },
    [logsDispatch]
  );
  const setShowFilter = useCallback(
    (payload: LogsShowFilterType) => {
      logsDispatch({ type: LogsActionType.SetShowFilter, payload });
    },
    [logsDispatch]
  );

  // alarms context
  const { state: alarmsState, dispatch: alarmsDispatch } = useContext(AlarmsContext);

  const setFromFilter = useCallback(
    (payload: AlarmFromDatesType) => {
      alarmsDispatch({ type: AlarmsActionType.SetFrom, payload });
    },
    [alarmsDispatch]
  );
  const setAcknowledgeFilter = useCallback(
    (payload: AcknowledgeFilterType) => {
      alarmsDispatch({ type: AlarmsActionType.SetAcknowledge, payload });
    },
    [alarmsDispatch]
  );
  const setShowSystemAlarmsFilter = useCallback(
    (payload: boolean) => {
      alarmsDispatch({ type: AlarmsActionType.SetShowSystemAlarms, payload });
    },
    [alarmsDispatch]
  );

  return {
    sharedState,
    setRangeFilter,
    setPageContext,
    setRefreshButton,
    setShowAllocatedSites,
    //
    graphState,
    setIntervalFilter,
    setFlowUnitFilter,
    setPressureUnitFilter,
    setMaintenanceSiteIdsFilter,
    setMaintenanceRangeTypeFilter,
    setGraphPage,
    //
    logsState,
    setIncludeDeviceCommands,
    setActiveCommands,
    setShowFilter,
    //
    alarmsState,
    setFromFilter,
    setAcknowledgeFilter,
    setShowSystemAlarmsFilter,
  };
};
